import { useEffect, useState } from 'react';
import styles from './SpotlightActorsSection.module.css';
import SectionHeader from '../../../../components/common/SectionHeader/SectionHeader';
import ActorCardsGrid from './ActorCardsGrid';
import { SPOTLIGHT_ACTORS_DATA } from '../../../../constants/landing';
import { getTalentList } from '../../../../api/talentApi';

const DUMMY_ACTORS = SPOTLIGHT_ACTORS_DATA.actors;
const GENDER_MAP = { MALE: '남성', FEMALE: '여성', male: '남성', female: '여성' };

/**
 * @component SpotlightActorsSection
 * @description 주목할 배우 섹션 — 최신 등록 배우 4명 실시간 노출, 없으면 더미 표시
 */
function SpotlightActorsSection({ onCardClick }) {
  const { header } = SPOTLIGHT_ACTORS_DATA;
  const [actors, setActors] = useState(DUMMY_ACTORS);

  useEffect(() => {
    getTalentList({ orderBy: 'latest', perpage: 4, callpage: 1 })
      .then(res => {
        const items = Array.isArray(res) ? res : (res?.content ?? []);
        if (items.length === 0) return; // 없으면 더미 유지
        const currentYear = new Date().getFullYear();
        setActors(
          items.slice(0, 4).map(item => {
            const medias = item.medias || [];
            const image =
              item.profileImageUrl ??
              medias.find(m => m.photoType === 'PROFILE_CLOSE_UP' && m.url)?.url ??
              null;
            const birthYear = item.birthDate ? new Date(item.birthDate).getFullYear() : null;
            return {
              id: item.slug || (item.talentProfileId ?? item.id),
              name: item.stageName || item.name,
              image,
              gender: GENDER_MAP[item.gender] || item.gender || '',
              age: birthYear !== null ? currentYear - birthYear : null,
              height: item.heightCm ?? null,
              skills: (item.skills || []).map(s => s.name || s.skillName || s).filter(Boolean),
            };
          })
        );
      })
      .catch(() => {}); // 에러 시 더미 유지
  }, []);

  return (
    <section className={styles.spotlightActorsSection}>
      <div className={styles.container}>
        <SectionHeader
          title={header.title}
          subtitle={header.subtitle}
          align="left"
          layout="split"
        />
        <ActorCardsGrid actors={actors} onCardClick={onCardClick} />
      </div>
    </section>
  );
}

export default SpotlightActorsSection;
